var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGmail = function SvgGmail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 25,
    viewBox: "0 0 32 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0002 24.0044H2.00092C1.47051 24.0044 0.96181 23.7936 0.586747 23.4185C0.211684 23.0434 0.000976563 22.5346 0.000976562 22.0041V2.00126C0.000976562 1.47075 0.211684 0.961971 0.586747 0.586845C0.96181 0.21172 1.47051 0.000976563 2.00092 0.000976562H30.0002C30.5306 0.000976562 31.0393 0.21172 31.4144 0.586845C31.7894 0.961971 32.0001 1.47075 32.0001 2.00126V22.0041C32.0001 22.5346 31.7894 23.0434 31.4144 23.4185C31.0393 23.7936 30.5306 24.0044 30.0002 24.0044Z",
    fill: "#EAEAEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00088 24.0044H2.00093C1.47051 24.0044 0.961813 23.7936 0.586749 23.4185C0.211685 23.0434 0.000976563 22.5346 0.000976563 22.0041V2.00126C0.000976557 1.73858 0.0527067 1.47847 0.153214 1.23578C0.253721 0.993098 0.401036 0.772589 0.586749 0.586845C0.772462 0.401102 0.992936 0.253762 1.23558 0.153239C1.47823 0.0527152 1.73829 0.000976562 2.00093 0.000976562C2.26357 0.000976562 2.52363 0.0527152 2.76628 0.153239C3.00893 0.253762 3.2294 0.401102 3.41511 0.586845C3.60082 0.772589 3.74814 0.993098 3.84865 1.23578C3.94915 1.47847 4.00088 1.73858 4.00088 2.00126V24.0044Z",
    fill: "#D54C3F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.999 24.0039H29.999C30.5294 24.0039 31.0381 23.7931 31.4132 23.418C31.7882 23.0429 31.9989 22.5341 31.9989 22.0036V2.00077C31.9989 1.47026 31.7882 0.961483 31.4132 0.586357C31.0381 0.211231 30.5294 0.000488281 29.999 0.000488281C29.4686 0.000488281 28.9599 0.211231 28.5848 0.586357C28.2097 0.961483 27.999 1.47026 27.999 2.00077V24.0039Z",
    fill: "#B63524"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.145 3.64086C31.3603 3.49043 31.544 3.29905 31.6854 3.07765C31.8268 2.85624 31.9232 2.60914 31.9692 2.35047C32.0151 2.09179 32.0096 1.82659 31.9531 1.57002C31.8966 1.31346 31.79 1.07054 31.6396 0.855141C31.4892 0.639743 31.2979 0.456084 31.0765 0.314648C30.8552 0.173213 30.6081 0.0767722 30.3495 0.0308317C30.0908 -0.0151087 29.8257 -0.00964885 29.5691 0.0468996C29.3126 0.103448 29.0697 0.209978 28.8544 0.360406L16.0013 9.71971L16 9.72038L15.9987 9.71971L3.14562 0.360406C2.71067 0.0566022 2.17288 -0.0619492 1.65054 0.0308317C1.1282 0.123613 0.664102 0.420125 0.360348 0.855141C0.0565931 1.29016 -0.0619392 1.82804 0.0308267 2.35047C0.123593 2.87289 0.420058 3.33706 0.855003 3.64086L0.801671 3.60152L16 14.6691L31.145 3.64086ZM31.199 3.60152L16 14.6691L31.199 3.60152Z",
    fill: "#DE5145"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9993 0.000490729C29.5733 0.000490729 29.178 0.133843 28.854 0.360541L16.001 9.71986L15.9997 9.72053L15.9983 9.71986L3.14531 0.360541C2.80964 0.125577 2.40971 -0.000151384 2 0.000490729H29.9993Z",
    fill: "#EFEFEF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00082 6.79324L0.630239 3.4541L0.628906 3.45677C0.699571 3.52344 0.774902 3.58479 0.8549 3.64079L0.801568 3.60145L4.00148 5.93178L4.00082 6.81724",
    fill: "#C64132"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7784 16.3967L4 24.0037L4.00067 6.70996L13.7764 16.394",
    fill: "#E3E3E3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7787 16.3964L16 14.6688L4.00098 5.93164V6.70975L13.7767 16.3938L13.7787 16.3964Z",
    fill: "url(#paint0_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3735 24.0037H27.9994V5.93115L15.9996 14.6691L13.7764 16.394L21.3735 24.0037Z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 4.00098,
    y1: 11.1644,
    x2: 16,
    y2: 11.1644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDCDCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 13.7764,
    y1: 14.9671,
    x2: 27.9994,
    y2: 14.9671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E2E2"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGmail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gmail.2bf3104e.svg";
export { ForwardRef as ReactComponent };